/* Nature's Melody — shared behavior for all nm- sections (chime sound, header, footer,
   collection audio previews). Pure Web Audio, no dependencies. Safe to load with `defer`.
   Multiple nm- sections on the same page each include a <script src="nm-home.js"> tag
   (so any single section works standalone) — that means this file can load and execute
   more than once per page. The guard below makes init() a no-op after the first run, so
   duplicate <script> tags never double-attach event listeners (which previously caused
   things like the audio preview button to start and immediately self-cancel playback). */
(function () {
  if (window.__nmHomeInit) return;
  window.__nmHomeInit = true;

  function init() {
    var ctx;
    function ac() { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); return ctx; }

    // A tuned chord = a real wind chime.
    var TONES = {
      bright:   [880.0, 1108.7, 1318.5, 1760.0],
      balanced: [523.25, 659.25, 783.99, 987.77],
      deep:     [261.63, 329.63, 392.00, 493.88]
    };

    function ring(freqs) {
      var c = ac(), t0 = c.currentTime;
      freqs.forEach(function (f, i) {
        var t = t0 + i * 0.08;
        var o = c.createOscillator(), o2 = c.createOscillator(), g = c.createGain(), g2 = c.createGain();
        o.type = "sine"; o2.type = "triangle";
        o.frequency.value = f; o2.frequency.value = f * 2.0;
        g2.gain.value = 0.12; o2.connect(g2); g2.connect(g);
        o.connect(g); g.connect(c.destination);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.28, t + 0.012);
        g.gain.exponentialRampToValueAtTime(0.0006, t + 2.6);
        o.start(t); o2.start(t); o.stop(t + 2.7); o2.stop(t + 2.7);
      });
      pulseWaves();
    }

    function pulseWaves() {
      document.querySelectorAll('[data-nm-w]').forEach(function (w, i) {
        w.classList.remove('nm-pulse');
        void w.getBBox();
        setTimeout(function () { w.classList.add('nm-pulse'); }, i * 90);
      });
    }

    // "Hear a chime" / "Choose by sound" prefer a real recorded product track (via each
    // button's data-audio, set in Liquid from product.metafields.custom.audio_preview) over
    // the synthesized chord. One shared <audio> element means starting a new one naturally
    // stops whichever was already playing. Falls back to the synthesized ring() for any
    // button whose category has no uploaded recording yet.
    var nmRealAudio = new Audio();
    function playChime(btn, freqs) {
      var url = btn.getAttribute('data-audio');
      if (url) {
        nmRealAudio.pause();
        if (nmRealAudio.src !== url) nmRealAudio.src = url;
        nmRealAudio.currentTime = 0;
        nmRealAudio.play().catch(function () {});
        pulseWaves();
      } else {
        ring(freqs);
      }
    }

    var hero = document.getElementById('nm-hearHero');
    if (hero) hero.addEventListener('click', function () { playChime(hero, TONES.balanced); });

    // Hero product slideshow
    (function () {
      var root = document.getElementById('nm-slider');
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.nm-slide'));
      var dotsWrap = document.getElementById('nm-dots');
      if (slides.length <= 1) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var speed = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      var cur = 0, timer = null;
      var dots = slides.map(function (_, i) {
        var d = document.createElement('button');
        d.className = 'nm-dot' + (i === 0 ? ' nm-on' : '');
        d.type = 'button';
        d.setAttribute('aria-label', 'Show slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(d);
        return d;
      });
      function go(i) {
        slides[cur].classList.remove('nm-on'); dots[cur].classList.remove('nm-on');
        cur = (i + slides.length) % slides.length;
        slides[cur].classList.add('nm-on'); dots[cur].classList.add('nm-on');
      }
      function restart() {
        if (timer) { clearInterval(timer); timer = null; }
        if (speed > 0 && !reduce) timer = setInterval(function () { go(cur + 1); }, speed);
      }
      root.addEventListener('mouseenter', function () { if (timer) { clearInterval(timer); timer = null; } });
      root.addEventListener('mouseleave', restart);
      restart();
    })();

    // ---- Header: sticky shadow, dropdowns, mobile drawer, search panel ----
    (function () {
      var header = document.getElementById('nm-header');
      if (header) {
        var onScroll = function () { header.classList.toggle('nm-scrolled', window.scrollY > 4); };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // Desktop dropdowns (click to open, click outside / Escape to close)
      var openItem = null;
      function closeDropdowns() {
        document.querySelectorAll('.nm-nav-item.nm-open').forEach(function (el) { el.classList.remove('nm-open'); });
        openItem = null;
      }
      document.querySelectorAll('.nm-nav-item').forEach(function (item) {
        var btn = item.querySelector('.nm-nav-link');
        if (!btn || !item.querySelector('.nm-dropdown')) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = item.classList.contains('nm-open');
          closeDropdowns();
          if (!isOpen) { item.classList.add('nm-open'); openItem = item; }
        });
      });
      document.addEventListener('click', function (e) {
        if (openItem && !openItem.contains(e.target)) closeDropdowns();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDropdowns(); });

      // Mobile drawer + search panel are `position: fixed`, but some themes put a
      // `transform` on an ancestor of the header (e.g. for a hide-on-scroll sticky
      // header) — a transformed ancestor becomes the containing block for any fixed
      // descendant, trapping it inside that box instead of the real viewport, which
      // shows up as the drawer being squashed/scroll-locked near the top. Moving both
      // to be direct children of <body> sidesteps that entirely.
      //
      // Gotcha: every nm- design token (--nm-paper, --nm-ink, ...) and the box-sizing
      // reset are declared scoped to the .nm-home class, not :root. Moving an element
      // out from under its .nm-home ancestor orphans it from both — the token
      // references resolve to nothing (transparent background, default text color) and
      // 100%-width children go back to content-box sizing and overflow past the
      // viewport, pushing the whole page into horizontal scroll. Carrying the
      // `nm-home` class along on the portaled element keeps both intact.
      var mobilenav = document.getElementById('nm-mobilenav');
      var searchPanelEl = document.getElementById('nm-search-panel');
      if (mobilenav && mobilenav.parentElement !== document.body) {
        mobilenav.classList.add('nm-home');
        document.body.appendChild(mobilenav);
      }
      if (searchPanelEl && searchPanelEl.parentElement !== document.body) {
        searchPanelEl.classList.add('nm-home');
        document.body.appendChild(searchPanelEl);
      }

      // Mobile drawer
      var burger = document.getElementById('nm-burger');
      var mobileClose = document.getElementById('nm-mobilenav-close');
      function openMobile() { if (mobilenav) { mobilenav.classList.add('nm-show'); document.body.style.overflow = 'hidden'; } }
      function closeMobile() { if (mobilenav) { mobilenav.classList.remove('nm-show'); document.body.style.overflow = ''; } }
      if (burger) burger.addEventListener('click', openMobile);
      if (mobileClose) mobileClose.addEventListener('click', closeMobile);
      document.querySelectorAll('.nm-mobilenav-toggle').forEach(function (t) {
        t.addEventListener('click', function () {
          var sub = document.getElementById(t.getAttribute('data-target'));
          if (sub) sub.classList.toggle('nm-show');
        });
      });

      // Search panel
      var searchBtn = document.getElementById('nm-search-btn');
      var searchPanel = document.getElementById('nm-search-panel');
      var searchInput = document.getElementById('nm-search-input');
      var searchClose = document.getElementById('nm-search-close');
      function openSearch() { if (searchPanel) { searchPanel.classList.add('nm-show'); if (searchInput) searchInput.focus(); } }
      function closeSearch() { if (searchPanel) searchPanel.classList.remove('nm-show'); }
      if (searchBtn) searchBtn.addEventListener('click', openSearch);
      if (searchClose) searchClose.addEventListener('click', closeSearch);
      if (searchPanel) searchPanel.addEventListener('click', function (e) { if (e.target === searchPanel) closeSearch(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSearch(); closeMobile(); } });
    })();

    var grid = document.getElementById('nm-grid');
    document.querySelectorAll('.nm-tone').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tone = btn.getAttribute('data-tone');
        document.querySelectorAll('.nm-tone').forEach(function (b) {
          b.classList.toggle('nm-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        playChime(btn, TONES[tone] || TONES.balanced);
        if (grid) grid.querySelectorAll('.nm-card').forEach(function (card) {
          var t = card.getAttribute('data-tone');
          // dim cards that don't match; cards with no tone stay visible
          card.classList.toggle('nm-dim', !!t && t !== tone);
        });
      });
    });

    // ---- Audio previews (collection cards + product page), mutually exclusive playback ----
    (function () {
      var AUDIO_WRAPPER_SELECTOR = '.nm-col-card, .nm-pg-audio';
      var btns = document.querySelectorAll('.nm-audio-btn');
      if (!btns.length) return;
      function findAudioBtn(el) {
        var wrapper = el.closest(AUDIO_WRAPPER_SELECTOR);
        return wrapper && wrapper.querySelector('.nm-audio-btn');
      }
      btns.forEach(function (btn) {
        var wrapper = btn.closest(AUDIO_WRAPPER_SELECTOR);
        var audio = wrapper && wrapper.querySelector('.nm-audio-el');
        if (!audio) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var wasPlaying = !audio.paused;
          document.querySelectorAll('.nm-audio-el').forEach(function (el) {
            if (el !== audio) {
              el.pause();
              var otherBtn = findAudioBtn(el);
              if (otherBtn) otherBtn.classList.remove('nm-playing');
            }
          });
          if (wasPlaying) { audio.pause(); btn.classList.remove('nm-playing'); }
          else { audio.play().catch(function () {}); btn.classList.add('nm-playing'); }
        });
        audio.addEventListener('ended', function () { btn.classList.remove('nm-playing'); });
      });
    })();

    // ---- Product page: gallery thumbnails, variant picker, quantity stepper ----
    (function () {
      var main = document.getElementById('nm-pg-main');
      if (!main) return;

      // Gallery thumbnails
      var mainItems = main.querySelectorAll('.nm-pg-main-item');
      document.querySelectorAll('.nm-pg-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-media-id');
          document.querySelectorAll('.nm-pg-thumb').forEach(function (t) { t.classList.toggle('nm-active', t === thumb); });
          mainItems.forEach(function (item) {
            var isTarget = item.getAttribute('data-media-id') === id;
            item.classList.toggle('nm-on', isTarget);
            if (!isTarget) {
              var media = item.querySelector('video');
              if (media) media.pause();
            }
          });
        });
      });

      // Quantity stepper
      var qtyInput = document.getElementById('nm-pg-qty-input');
      var qtyMinus = document.getElementById('nm-pg-qty-minus');
      var qtyPlus = document.getElementById('nm-pg-qty-plus');
      if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = v;
        });
        qtyPlus.addEventListener('click', function () {
          var v = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.value = v;
        });
      }

      // Variant picker
      var variantsEl = document.getElementById('nm-pg-variants-data');
      if (!variantsEl) return;
      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

      var swatches = document.querySelectorAll('.nm-pg-swatch');
      var optionGroups = document.querySelectorAll('.nm-pg-option');
      var idInput = document.getElementById('nm-pg-variant-id');
      var priceEl = document.getElementById('nm-pg-price');
      var atcBtn = document.getElementById('nm-pg-atc');
      var atcLabel = document.getElementById('nm-pg-atc-label');
      var stockEl = document.getElementById('nm-pg-stock');

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function currentSelection() {
        var sel = [];
        optionGroups.forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var active = group.querySelector('.nm-pg-swatch.nm-active');
          sel[idx] = active ? active.getAttribute('data-value') : null;
        });
        return sel;
      }

      function findVariant(sel) {
        return variants.filter(function (v) {
          return sel.every(function (val, i) { return val == null || v.options[i] === val; });
        })[0];
      }

      function render() {
        var sel = currentSelection();
        var variant = findVariant(sel);

        optionGroups.forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var labelSpan = group.querySelector('.nm-pg-opt-current');
          if (labelSpan && sel[idx]) labelSpan.textContent = sel[idx];
          group.querySelectorAll('.nm-pg-swatch').forEach(function (sw) {
            var testSel = sel.slice(); testSel[idx] = sw.getAttribute('data-value');
            var exists = variants.some(function (v) {
              return testSel.every(function (val, i) { return val == null || v.options[i] === val; });
            });
            sw.disabled = !exists;
          });
        });

        if (!variant) return;
        idInput.value = variant.id;
        if (variant.featured_media && main) {
          var target = main.querySelector('.nm-pg-main-item[data-media-id="' + variant.featured_media.id + '"]');
          if (target) {
            main.querySelectorAll('.nm-pg-main-item').forEach(function (item) { item.classList.toggle('nm-on', item === target); });
            document.querySelectorAll('.nm-pg-thumb').forEach(function (t) {
              t.classList.toggle('nm-active', t.getAttribute('data-media-id') === String(variant.featured_media.id));
            });
          }
        }
        if (priceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML = '<span class="nm-was">' + money(variant.compare_at_price) + '</span><span class="nm-now">' + money(variant.price) + '</span>';
          } else {
            priceEl.textContent = money(variant.price);
          }
        }
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (stockEl) {
          if (!variant.available) { stockEl.textContent = 'Currently out of stock'; stockEl.classList.add('nm-out'); }
          else { stockEl.textContent = ''; stockEl.classList.remove('nm-out'); }
        }
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (sw.disabled) return;
          var group = sw.closest('.nm-pg-option');
          group.querySelectorAll('.nm-pg-swatch').forEach(function (s) { s.classList.toggle('nm-active', s === sw); });
          render();
        });
      });

      render();
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
